import React from 'react';
import {Box, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';
import LoadingLottieAnimation from '../../../components/app-specific/lottie-animations/loading';
import {useSuggestiveSellingPending} from '../hooks/use-suggestive-selling-pending';

const SuggestiveSellingSectionPending = ({
                                             pendingKey,
                                             showLabel = true,
                                             height = 96,
                                             sx,
                                         }) => {
    const {t} = useTranslation('dialogs', {keyPrefix: 'app-specific.suggestive-selling'});
    const pending = useSuggestiveSellingPending(pendingKey);

    if (!pending) {
        return null;
    }

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                py: 2,
                gap: 1,
                ...sx,
            }}
            aria-busy
            aria-live={'polite'}
        >
            <LoadingLottieAnimation width={height * 2} height={height}/>
            {
                showLabel &&
                <Typography variant={'body2'} color={'text.secondary'}>
                    {t('checkingAddons')}
                </Typography>
            }
        </Box>
    );
};

export default SuggestiveSellingSectionPending;
